"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Flex_1 = __importDefault(require("./Flex"));
var IconField = function (_a) {
    var children = _a.children;
    var childrenArray = react_1["default"].Children.toArray(children).filter(function (child) { return child.type.isField || child.type.isIcon; });
    var styledChildren = childrenArray.map(function (child, i) {
        if (child.type.isIcon) {
            return react_1["default"].cloneElement(child, {
                style: __assign(__assign({}, child.props.style), { flex: 'none', alignSelf: 'center', marginLeft: i === 0 ? 8 : -32, marginRight: i === 0 ? -32 : 8 })
            });
        }
        return react_1["default"].cloneElement(child, {
            style: __assign(__assign({}, child.props.style), { paddingLeft: i === 0 ? undefined : 40, paddingRight: i === children.length - 1 ? undefined : 40 })
        });
    });
    return react_1["default"].createElement(Flex_1["default"], null, styledChildren);
};
exports["default"] = IconField;
//# sourceMappingURL=IconField.js.map